<template>
  <div class="animated fadeIn">
    <!-- <StyledDialog>
      <div slot="header">
        <h2>{{seminar.restaurant_edit.CommonName}}</h2>
      </div>
      <div slot="details">
        <div>{{seminar.restaurant_edit.Address1}} {{seminar.restaurant_edit.Address2}}</div>
        <div>{{seminar.restaurant_edit.City }}</div>
      </div>
      <span slot="entityType">location</span>
    </StyledDialog>-->
    <b-row>
      <b-col lg="12">
        <!-- <b-card>
        <div slot="header">User Profile</div>-->
        <b-form @submit.prevent="save">
          <b-row>
            <b-col sm="12">
              <b-form-group>
                <CoolSelect
                  v-model="seminar.contact_edit.VendorID"
                  placeholder="Vendor"
                  theme="bootstrap"
                  tooltip="Vendor"
                  :items="seminar.vendors"
                  item-text="Name"
                  item-value="VendorID"
                  id="VendorID"
                >
                  <template slot="input-before">
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth">Vendor</b-input-group-text>
                    </b-input-group-prepend>
                  </template>
                  <!-- <template slot="item" slot-scope="{ item }">
                    <div class="item">
                      <img :src="item.thumbnail" class="logo" />
                      <span class="item-name">{{ item.CommonName }}</span>
                    </div>
                  </template>-->
                </CoolSelect>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Name*</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="seminar.contact_edit.Name"
                    placeholder="Contact Name"
                    required
                    type="text"
                    autocomplete="off"
                    id="Name"
                    @change.native="addDirtyField"
                  ></b-form-input>
                  <!-- <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-registered appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>-->
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Title</b-input-group-text>
                  </b-input-group-prepend>

                  <b-form-input
                    v-model.lazy="seminar.contact_edit.Title"
                    placeholder="Title"
                    type="text"
                    autocomplete="off"
                    id="Title"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                  <!-- 
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-globe"></i>
                    </b-input-group-text>
                  </b-input-group-append>-->
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Phone</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="seminar.contact_edit.Phone1"
                    placeholder="Primary Phone"
                    type="text"
                    autocomplete="off"
                    id="Phone1"
                    v-mask="'(###) ###-####'"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                  <!-- <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-registered appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>-->
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Cell/Mobile</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="seminar.contact_edit.Phone2"
                    placeholder="Cell/Mobile"
                    type="text"
                    autocomplete="off"
                    id="Phone2"
                    v-mask="'(###) ###-####'"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                  <!-- <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-registered appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>-->
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Email</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="seminar.contact_edit.Email"
                    placeholder="Email Address"
                    type="email"
                    autocomplete="off"
                    id="Email"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                  <!-- <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-envelope appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>-->
                </b-input-group>
              </b-form-group>
            </b-col>
            <!-- <b-col md="6">
              <b-form-radio-group
                class="mr-3"
                id="radiosBtn"
                buttons
                button-variant="outline-primary"
                v-model="seminar.contact_edit.Include"
                @change.native="addDirtyFieldRadio"
                name="radiosBtn"
              >
                <b-form-radio class="mx-0 longStandardizedRadioWidth" value="true">Include</b-form-radio>
                <b-form-radio class="mx-0 longStandardizedRadioWidth" value="false">Client Care</b-form-radio>
              </b-form-radio-group>
            </b-col>-->
            <b-col md="6">
              <c-switch
                width="100px"
                class="mx-3 pt-2"
                color="primary"
                variant="pill"
                label
                id="Include"
                v-model="seminar.contact_edit.Include"
                v-on:change.native="addDirtyFieldSwitch"
              />
              <span class="text-muted">Receives Order Alerts</span>
              <!-- <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-envelope appendIcon"></i>
                    </b-input-group-text>
              </b-input-group-append>-->
            </b-col>
          </b-row>

          <b-row v-if="false">
            <b-col md="12">
              <b-card>
                <div slot="header">
                  <a v-b-toggle.collapse2 style="cursor:pointer;">
                    <i class="fa fa-caret-down fa-lg mr-2" v-if="seen" @click="toggleVisibility" />
                    <i class="fa fa-caret-up fa-lg mr-2" v-if="!seen" @click="toggleVisibility" />
                    <span v-if="seen" @click="toggleVisibility">More</span>
                    <span v-if="!seen" @click="toggleVisibility">Less</span>
                  </a>
                </div>
                <b-collapse id="collapse2" class="mt-2">
                  <b-tabs>
                    <b-tab active>
                      <template slot="title">
                        <i class="fa fa-wrench"></i>
                        <span class="ml-1">Service</span>
                      </template>
                      <!-- <b-list-group-item class="pt-0" style="border: none; ">
                        <b-row>
                          <b-button
                            class="mr-0 ml-auto float-right"
                            size="sm"
                            variant="success"
                            @click="addLocation"
                          >
                            <i class="fa fa-plus"></i>
                            Add
                          </b-button>
                        </b-row>
                      </b-list-group-item>-->
                      <b-list-group>
                        <!-- <LocationRow
                          v-for="location in seminar.restaurant_edit.Locations"
                          :key="location.LocationID"
                          :location="location"
                        />-->
                      </b-list-group>
                    </b-tab>
                    <b-tab>
                      <template slot="title">
                        <i class="fa fa-dollar"></i>
                        <span class="ml-1">Sales</span>
                      </template>
                      <!-- <b-list-group-item class="pt-0" style="border: none; ">
                        <b-row>
                          <b-button
                            class="mr-0 ml-auto float-right"
                            size="sm"
                            variant="success"
                            @click="addContact"
                          >
                            <i class="fa fa-plus"></i>
                            Add
                          </b-button>
                        </b-row>
                      </b-list-group-item>-->
                      <b-list-group>
                        <!-- <ContactRow
                          v-for="contact in seminar.restaurant_edit.Contacts"
                          :key="contact.ContactID"
                          :contact="contact"
                        />-->
                      </b-list-group>
                    </b-tab>
                    <b-tab>
                      <template slot="title">
                        <i class="fa fa-cogs"></i>
                        <span class="ml-1">Parts</span>
                      </template>
                    </b-tab>
                    <b-tab>
                      <template slot="title">
                        <i class="fa fa-image"></i>
                        <span class="ml-1">Graphics</span>
                      </template>
                    </b-tab>
                  </b-tabs>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>

          <div class="form-group form-actions" style="float:right;">
            <b-button class="mr-2 mt-2" size="md" variant="outline-primary" @click="back">
              <!-- <i class="fa fa-close"></i> -->
              Close
            </b-button>
            <b-button
              class="mr-0 mt-2"
              type="submit"
              size="md"
              variant="primary"
              :disabled="isClean"
            >
              <i class="fa fa-save"></i>
              Save
            </b-button>
          </div>
          <div class="form-group form-actions" style="float:right;">
            <b-alert
              class="btn mr-4 mt-2"
              :show="dismissCountDown"
              fade
              variant="light"
              :dismissed="dismissCountdown=0"
              @dismiss-count-down="countDownChanged"
            >
              Your information has been saved
              <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
            </b-alert>
            <b-alert
              class="btn mr-4 mt-2"
              :show="dismiss2CountDown"
              fade
              variant="danger"
              :dismissed="dismiss2Countdown=0"
              @dismiss-count-down="countDown2Changed"
            >
              Your information could not be saved. Check all fields carefully.
              <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
            </b-alert>
          </div>
        </b-form>
        <!-- </b-card> -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import StyledDialog from "@/components/dialogs/StyledModal.vue";
import { required, email, helpers } from "vuelidate/lib/validators";
const alpha = helpers.regex("alpha", /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/);
import { Switch as cSwitch } from "@coreui/vue";
import { CoolSelect } from "vue-cool-select";

export default {
  name: "ContactProfile",
  data() {
    return {
      selected: [], // Must be an array reference!
      dirtyFields: [],
      show: true,
      seen: true,
      isSaving: false,
      isSaved: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      dismiss2Secs: 3,
      dismiss2CountDown: 0,
      showDismissibleAlert: false,
    };
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    toggleVisibility() {
      this.seen = !this.seen;
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    countDown2Changed(dismiss2CountDown) {
      this.dismiss2CountDown = dismiss2CountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    save() {
      // this.$v.$touch();
      // if (this.$v.$error) {
      //   this.dismiss2CountDown = this.dismiss2Secs;
      // } else {
      //   this.$store
      //     .dispatch("dealership/Save", {
      //       client: this.$store.state.seminar.restaurant_edit,
      //       fields: this.dirtyFields
      //     })
      //     .then(
      //       (this.dirtyFields = [])((this.dismissCountDown = this.dismissSecs))
      //     );
      // }
      this.$v.$touch();
      if (this.$v.$error) {
        this.dismiss2CountDown = this.dismiss2Secs;
      } else {
        this.$store
          .dispatch("saveOp/BuildSaveOperation")
          .then(
            this.$store
              .dispatch("saveOp/EmitSave")
              .then(
                (this.dirtyFields = [])(
                  (this.dismissCountDown = this.dismissSecs)
                )(this.$store.state.saveOp.DestroySaveOperation)
              )
          );
      }
    },

    addDirtyField: function (event) {
      this.dirtyFields = this.dirtyFields.filter(
        (dirtyField) => dirtyField.FieldName !== event.target.id
      );
      this.dirtyFields.push({
        FieldName: event.target.id,
        FieldValue: event.target.value,
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    addDirtyFieldWatch: function (field, newValue) {
      this.dirtyFields = this.dirtyFields.filter(
        (dirtyField) => dirtyField.FieldName !== field
      );
      this.dirtyFields.push({
        FieldName: field,
        FieldValue: newValue,
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    addDirtyFieldSwitch: function (event) {
      this.dirtyFields = this.dirtyFields.filter(
        (dirtyField) => dirtyField.FieldName !== event.target.id
      );
      this.dirtyFields.push({
        FieldName: event.target.id,
        FieldValue: event.target.checked.toString(),
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
  },
  computed: {
    ...mapState(["seminar"]),
    ...mapActions("saveOp", ["Save", "EmitSave"]),
    isClean() {
      return this.dirtyFields.length === 0;
    },
  },
  components: {
    StyledDialog,
    cSwitch,
    CoolSelect,
  },
  created() {
   },
  watch: {
    "$store.state.seminar.contact_edit.VendorID": function () {
       this.addDirtyFieldWatch(
        "VendorID",
        this.$store.state.seminar.contact_edit.VendorID
      );
    },
  },
  mounted() {
    this.$store.state.saveOp.localUrl = "/Seminar/SaveContact/";
    this.$store.state.saveOp.localVariableName = "_c";
    this.$store.state.saveOp.localVariableObject = this.$store.state.seminar.contact_edit;
    this.$store.state.saveOp.localFieldToSet = "ContactID";
    this.$store.state.saveOp.localReturnObject = "SaveContactResult";
  },
  validations: {
    seminar: {
      contact_edit: {
        Name: {
          required,
        },
      },
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.input-group-text {
  color: #111;
}
</style>
